import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { env } from '../core/error-handler/env';
import { Category } from '../models/category';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  baseUrl: string = env.baseUrl;

  constructor(private httpClient: HttpClient) { }

  getAllCategories(): Observable<Category[]> {
    const url = `${this.baseUrl}Category`;
    return this.httpClient.get<Category[]>(url);
  }

  delete(id) {
    const url = `${this.baseUrl}Category/${id}`;
    return this.httpClient.delete<void>(url);
  }

  update(category: Category) {
    const url = `${this.baseUrl}Category/${category.id}`;
    return this.httpClient.put<Category>(url, category);
  }

  add(category: Category) {
    const url = '${this.baseUrl}Category';
    return this.httpClient.post<Category>(url, category);
  }

  getSubCategories(id: string) {
    const url = `${this.baseUrl}Category/${id}/subcategories`;
    return this.httpClient.get<Category[]>(url);
  }

  getAllCategoriesForDropDown() {
    const url = `${this.baseUrl}Category/dropdown`;
    return this.httpClient.get<Category[]>(url);
  }

  getAllDocumentsByFolder(data?: any): Observable<any> {
    let queryParams = new HttpParams({ fromObject: data });
    return this.httpClient.get(`${this.baseUrl}GetAllDocumentsByFolder`, { params: queryParams })
  }

  CategoryCreateJob(jobCategory) {
    const url = `${this.baseUrl}Category/createJob`;
    return this.httpClient.post<any>(url, jobCategory)
  }

  CategoryUpdateClient(clientCategory) {
    const url = `${this.baseUrl}Category/updateClient`;
    return this.httpClient.put<any>(url, clientCategory);
  }

  CategoryCreateClient(clientCategory) {
    const url = `${this.baseUrl}Category/createClient`;
    return this.httpClient.post<any>(url, clientCategory);
  }

  updateRolePermission(permissionData: any) {
    const url = `${env.baseUrl}Category/updateRolePermission`;
    return this.httpClient.post<any>(url, permissionData);
  }

  updateClientCategory(clientCategory: any) {
    const url = `${this.baseUrl}Category/updateClient`;
    return this.httpClient.put<any>(url, clientCategory);
  }

}
